import { css, html, nothing } from "lit";
import { state } from "lit/decorators.js";
import "../Dropdown/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { updateCSSVariables, getTooltipClasses } from "./utils.js";
import { arrowStyles, getArrowClasses, placements } from "../../../styles/dropdownArrow.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfTooltip = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_placement = "top";
    this.dsf_flip = false;
    this.dsf_shift = false;
    this.dsf_padding = 8;
    this.dsf_hide = false;
    this.dsf_size = "medium";
    this.dsf_type = "dark";
    this.disabled = false;
    this._open = false;
  }
  handleSelectMouseEnter() {
    this._open = true;
  }
  handleSelectMouseLeave() {
    this._open = false;
  }
  render() {
    const arrowClasses = getArrowClasses(this);
    updateCSSVariables(this);
    const tooltipClasses = getTooltipClasses(this);
    const titleClasses = this.dsf_size === "small" ? "dsf-text-xxs-semibold" : "dsf-text-xs-semibold";
    return this.disabled ? html`<slot name="anchor" class="flex-auto"></slot>` : html`
          <dsf-dropdown
            class="flex-auto"
            .dsf_flip=${this.dsf_flip}
            .dsf_shift=${this.dsf_shift}
            .dsf_hide=${this.dsf_hide}
            .dsf_placement=${this.dsf_placement}
            .dsf_open=${this._open}
            .dsf_offset=${7}
            dsf_arrow="#arrow"
          >
            <div
              slot="anchor"
              part="anchor"
              class="flex flex-auto"
              aria-labelledby="label"
              aria-describedby="tooltipContent"
              @mouseenter=${this.handleSelectMouseEnter}
              @mouseleave=${this.handleSelectMouseLeave}
            >
              <slot name="anchor"></slot>
            </div>

            <div id="tooltipContent" class=${tooltipClasses} part="dropdown" role="tooltip">
              ${this.dsf_title ? html`<span class=${titleClasses}>${this.dsf_title}</span>` : nothing}
              <slot></slot>
            </div>
            <div id="arrow" class=${arrowClasses}></div>
          </dsf-dropdown>
        `;
  }
};
DsfTooltip.styles = [
  ...BaseComponent.styles,
  css`
      dsf-dropdown::part(dropdown) {
        z-index: var(--dsf-z-index-tooltip);
      }

      ::slotted([slot='anchor']) {
        flex-grow: 1;
      }
    `,
  arrowStyles
];
__decorateClass([
  prop({ type: String })
], DsfTooltip.prototype, "dsf_title", 2);
__decorateClass([
  prop({
    type: String,
    reflect: true,
    validator: (value) => placements.includes(value)
  })
], DsfTooltip.prototype, "dsf_placement", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTooltip.prototype, "dsf_flip", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTooltip.prototype, "dsf_shift", 2);
__decorateClass([
  prop({ type: Number, validator: (value) => value >= 0 })
], DsfTooltip.prototype, "dsf_padding", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTooltip.prototype, "dsf_hide", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTooltip.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTooltip.prototype, "dsf_type", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTooltip.prototype, "disabled", 2);
__decorateClass([
  state()
], DsfTooltip.prototype, "_open", 2);
DsfTooltip = __decorateClass([
  defineElement("dsf-tooltip")
], DsfTooltip);
export {
  DsfTooltip
};
